module.exports = __webpack_public_path__ + "static/media/default.faeb61cd.svg";